import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.function.name";
import "core-js/modules/es.string.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { areaList, agentList, agentHandle, agentDelete } from '@/api/apis';
export default {
  name: 'regionAgent',
  data: function data() {
    return {
      loading: false,
      searchKeyword: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      areaOptions: [],
      areaMap: {},
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false
      },
      // 添加弹窗
      addDialogVisible: false,
      addLoading: false,
      addForm: {
        number: '',
        region: []
      },
      addRules: {
        number: [{
          required: true,
          message: '请输入会员编号',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择区域',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    filteredData: function filteredData() {
      var result = this.tableData; // 关键词搜索

      if (this.searchKeyword) {
        var kw = this.searchKeyword.toLowerCase();
        result = result.filter(function (item) {
          return item.number && item.number.toLowerCase().includes(kw) || item.province && item.province.includes(kw) || item.city && item.city.includes(kw) || item.district && item.district.includes(kw);
        });
      }

      return result;
    },
    pagedData: function pagedData() {
      return this.filteredData;
    }
  },
  mounted: function mounted() {
    this.loadAreaOptions();
    this.loadData();
  },
  methods: {
    // 加载省市区数据
    loadAreaOptions: function loadAreaOptions() {
      var _this = this;

      areaList({}).then(function (res) {
        _this.areaOptions = res || [];

        _this.buildAreaMap();
      });
    },
    // 构建 id -> name 的映射
    buildAreaMap: function buildAreaMap() {
      var map = {};

      var walk = function walk(nodes) {
        if (!nodes) return;

        for (var i in nodes) {
          map[nodes[i].id] = nodes[i].name;
          if (nodes[i].children) walk(nodes[i].children);
        }
      };

      walk(this.areaOptions);
      this.areaMap = map;
    },
    // 根据 id 获取区域名称
    getAreaName: function getAreaName(id) {
      if (!id) return '';
      return this.areaMap[id] || id;
    },
    // 加载代理区域列表
    loadData: function loadData() {
      var _this2 = this;

      this.loading = true;
      agentList({
        page: this.currentPage,
        limit: this.pageSize
      }).then(function (res) {
        var data = res && res.data ? res.data : res;
        _this2.tableData = data && data.rows || [];
        _this2.total = data && data.count || 0;
        _this2.loading = false;
      }).catch(function () {
        _this2.tableData = [];
        _this2.total = 0;
        _this2.loading = false;
      });
    },
    // 搜索
    onSearchChange: function onSearchChange() {
      this.currentPage = 1;
      this.loadData();
    },
    onSizeChange: function onSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadData();
    },
    onPageChange: function onPageChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 显示添加弹窗
    showAddDialog: function showAddDialog() {
      var _this3 = this;

      this.addForm = {
        number: '',
        region: []
      };
      this.addDialogVisible = true;
      this.$nextTick(function () {
        if (_this3.$refs.addForm) {
          _this3.$refs.addForm.clearValidate();
        }
      });
    },
    // 提交添加
    onAddSubmit: function onAddSubmit() {
      var _this4 = this;

      this.$refs.addForm.validate(function (valid) {
        if (!valid) return;

        if (_this4.addForm.region.length < 3) {
          _this4.$message({
            message: '请选择到区/县级',
            type: 'warning'
          });

          return;
        }

        _this4.addLoading = true;
        var region = _this4.addForm.region;

        var province = _this4.areaOptions.find(function (p) {
          return p.id === region[0];
        });

        var city = province ? province.children.find(function (c) {
          return c.id === region[1];
        }) : null;
        var district = city ? city.children.find(function (d) {
          return d.id === region[2];
        }) : null;
        var data = {
          number: _this4.addForm.number,
          province: province ? province.id : '',
          city: city ? city.id : '',
          district: district ? district.id : ''
        };
        agentHandle(data).then(function (res) {
          _this4.$message({
            message: '添加成功',
            type: 'success'
          });

          _this4.addDialogVisible = false;
          _this4.addLoading = false;

          _this4.loadData();
        }).catch(function () {
          _this4.addLoading = false;
        });
      });
    },
    // 移除代理区域
    onRemove: function onRemove(row) {
      var _this5 = this;

      this.$confirm("\u786E\u8BA4\u79FB\u9664\u300C".concat(row.number, "\u300D\u7684\u4EE3\u7406\u8D44\u683C\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        agentDelete({
          number: row.number
        }).then(function (res) {
          _this5.$message({
            message: '移除成功',
            type: 'success'
          });

          _this5.loadData();
        });
      }).catch(function () {});
    }
  }
};